import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useContact } from "../../contexts";
import { ACTIONS } from "../../constants/actions";
import { adminBlogColumns } from "../../constants/data_columns/blogs";
import HrmLoader from "../components/hrm_loader";
import { HRMTable } from "../components/hrm_table";
import NoData from "../../assets/No-Search-Result.png";
import DeleteModal from "../modals/delete_model";
import { useNavigate } from "react-router-dom";
import { componentRoutes } from "../../constants/componentRoutes";
import { adminContactUsColumns } from "../../constants/data_columns/contact_us";
import { adminNewsLetterColumns } from "../../constants/data_columns/news_letter";
import { APIS } from "../../api";
import axios from "../../api/axios";
import { toast } from "react-toastify";
import { loginLogsColumns } from "../../constants/data_columns/loginLogs";

const LogList = () => {

  const [newsLatterData, setNewsLatterData] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [isDeleteFormVisible, setDeleteFormVisible] = useState(false);
  const [blogId, setBlogId] = useState(null);
  const [viewId, setViewId] = useState(null);
  const [newsLoader, setMetaLoader] = useState(false);


  const [is_delete, set_is_delete] = useState(false);


  // const { onLoadContact, onDeleteContact, contactLoader: newsLoader, contacts } = useContact();

  const navigate = useNavigate();

  const fetchData = async () => {
    setMetaLoader(true);
    try {
      const { data } = await axios.post(APIS.LIST_LOGS_TAG);
      if (data.code == 1) {
        // setPages(data?.data);
        setNewsLatterData(
          data?.data?.map((item) => {
            return {
              id: item.id,
              email: item.email,
              date: item.date,
              time: item.time,
            }
          })
        );
      } else {
        setNewsLatterData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setNewsLatterData([]);
      setMetaLoader(false);
    } finally {
      setMetaLoader(false);
    }
  };

  useEffect(() => {
    fetchData()
  }, [is_delete])

  // useEffect(() => {
  //   onLoadContact();
  // }, [onLoadContact]);

  // useEffect(() => {
  //   if (contacts?.length > 0) {
  //     setContactData(
  //       contacts.map((item) => {
  //         return {
  //           id: item.id,
  //           // name: item.name,
  //           email: item.email,
  //           // phone_number: item.phone_number,
  //           // company_name: item.company_name,
  //           // description: item.description
  //         }
  //       })
  //     )
  //   }
  // }, [contacts]);

  //     useEffect(() => {
  //       if (blogId !== null) {
  //           navigate(componentRoutes.editBlog.replace(':blog_id', blogId));
  //       }
  //   }, [navigate, blogId]);

  //   useEffect(() => {
  //     if (viewId !== null) {
  //         navigate(componentRoutes.viewBlog.replace(':id', viewId));
  //     }
  // }, [navigate, viewId]);

  const handleDelete = async () => {
    if (!selectedId) return;
    set_is_delete(true)
    try {
      const { data } = await axios.post(APIS.DELETE_NEWSLETTER_TAG, { news_letter_id: selectedId });
      if (data.code == 1) {
        toast.success("News letter deleted successfully!");
        set_is_delete(false)
      } else {
        setNewsLatterData([]);
        set_is_delete(false)
      }
    } catch (error) {
      //   toast.error("Failed to delete department. Please try again.");
      //   console.error(error);
    } finally {
      setDeleteFormVisible(false);
      setSelectedId(null);
      set_is_delete(false)

    }
  };

  const onSelectAction = useCallback(
    async (row, value) => {

      if (ACTIONS.EDIT === value) {
        //  setInitialValues(row);
        setBlogId(row.id);
      } else if (ACTIONS.DELETE === value) {
        setSelectedId(row.id);
        setDeleteFormVisible(true)

      }
      else {
      }
    },
    []
  );

  const columns = useMemo(() => {
    return loginLogsColumns({ onSelectAction });
  }, [onSelectAction]);

  return (
    // <div>
    //     <p>hello</p>
    // </div>
    <div>
      <div className="col-span-12 md:order-1 xl:col-span-8 2xl:col-span-6">
        <h5 className="mb-2">Login Logs List</h5>
      </div>
      <div className="card">
        <div className="card-body">
          {newsLoader ? (
            <HrmLoader />
          ) : newsLatterData?.length > 0 ? (
            <>
              <HRMTable data={newsLatterData} columns={columns} />
              {isDeleteFormVisible &&
                <DeleteModal
                  isVisible={isDeleteFormVisible}
                  onClose={() => {
                    setDeleteFormVisible(false)
                    setSelectedId(null);
                  }}
                  onConfirm={handleDelete}
                  title="Delete News Letter"
                  description="Are you sure you want to delete this News Letter?"
                />
              }
            </>
          ) : (
            <img src={NoData} alt="No Data Available" className="w-200 h-200 mx-auto" />
          )}
        </div>
      </div>
    </div>
  )
};

export default LogList;